// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"a6d49c49","263":"1b118c9c","496":"54ee21e4"}[chunkId] + ".chunk.js";
};